module.exports = __webpack_public_path__ + "img/39_53.0a5c7cef.png";